import React from 'react';
import {
    GiOakLeaf,
    GiVineLeaf,
    GiFern,
    GiFlowerEmblem,
    GiLotusFlower,
    GiClover,
    GiMapleLeaf,
    GiHighGrass,
    GiPlantRoots,
    GiFlowerPot,
    GiHerbsBundle,
    GiWheat,
    GiPalmTree,
    GiRose
} from 'react-icons/gi';

// Enhanced leaves and flowers using GameIcons
// These are purely decorative elements - aria-hidden should be passed via props

export const Leaf1 = ({ className, ...props }) => (
    <GiOakLeaf className={className} {...props} />
);

export const Vine1 = ({ className, ...props }) => (
    <GiVineLeaf className={className} {...props} />
);

export const FernLeaf = ({ className, ...props }) => (
    <GiFern className={className} {...props} />
);

export const Flower1 = ({ className, ...props }) => (
    <GiFlowerEmblem className={className} {...props} />
);

// New nature decorations for more variety
export const Lotus = ({ className, ...props }) => (
    <GiLotusFlower className={className} {...props} />
);

export const Clover = ({ className, ...props }) => (
    <GiClover className={className} {...props} />
);

export const MapleLeaf = ({ className, ...props }) => (
    <GiMapleLeaf className={className} {...props} />
);

export const Grass = ({ className, ...props }) => (
    <GiHighGrass className={className} {...props} />
);

export const Roots = ({ className, ...props }) => (
    <GiPlantRoots className={className} {...props} />
);

export const FlowerPot = ({ className, ...props }) => (
    <GiFlowerPot className={className} {...props} />
);

export const Herbs = ({ className, ...props }) => (
    <GiHerbsBundle className={className} {...props} />
);

export const Wheat = ({ className, ...props }) => (
    <GiWheat className={className} {...props} />
);

export const Palm = ({ className, ...props }) => (
    <GiPalmTree className={className} {...props} />
);

export const Rose = ({ className, ...props }) => (
    <GiRose className={className} {...props} />
);
